import { SearchData, MenuOption } from "../../../../common/dataClass/Default"

/**搜索数据 */
class AnalysisSearchData extends SearchData{
  constructor() {
    super()
    /**店铺 */
    this.store = ''
    /**国家站点 */
    this.countrySite = ''
  }
  /**搜索数据请求体 */
  get getSearchAxiosBody(){
    return {
      page: this.page,
      row: 10,
      saleStatus: 0,
      storeName: this.store? this.store : null,
      countryArea: this.countrySite? this.countrySite : null,
      textFilter: this.text? this.text : null
    }
  }
}

/**销售趋势分析菜单 */
class AnalysisMenuOption extends MenuOption{
  constructor(name, id){
    super(name, id)
  }
}

class AnalysisNewModule{
  /**菜单 */
  static NEWMANUITEM(){
    let arr = {
      orderNum: new AnalysisMenuOption('订单数量', 'orderNum'),
      salesNum: new AnalysisMenuOption('商品销量', 'salesNum'),
      salesPrice: new AnalysisMenuOption('销售额', 'salesPrice'),
      profitRate: new AnalysisMenuOption('利润率', 'profitRate')
    }
    return arr
  }
  /**分析图默认数据 */
  static EchartsDefaultData(){
    let obj = {
      xAxis: {
        type: 'category',
        data: ['2026-01-01', '2026-01-03', '2026-01-05', '2026-01-07', '2026-01-09', '2026-01-11', '2026-01-13']
      },
      yAxis: {
        type: 'value'
      },
      legend: {
        data: ['订单数量', '商品销量', '销售额', '利润率']
      },
      series: [{
        name: '订单数量',
          data: [820, 932, 901, 534, 1890, 1530, 1320],
          type: 'line',
          smooth: true
        },{
          name: '商品销量',
          data: [710, 652, 721, 804, 1580, 1400, 1390],
          type: 'line',
          smooth: true
        },{
          name: '销售额',
          data: [900, 836, 809, 930, 1200, 1550, 1300],
          type: 'line',
          smooth: true
        },{
          name: '利润率',
          data: [590, 522, 901, 1074, 1620, 1670, 1290],
          type: 'line',
          smooth: true
        }]
    }
    return obj
  }
}

export { AnalysisSearchData, AnalysisNewModule }
